export const trackingLinkErrorMessage = (
  error: unknown,
  t: (key: string) => string,
): string => {
  const message = error instanceof Error ? error.message : "";
  if (message === "noUnit") return t("detail.trackingLinkNeedsUnit");
  if (message === "noCompany") return t("detail.noCompanySelected");
  if (message === "missingPublicUrl") return t("detail.linkError");
  if (message === "linkNotActive") return t("detail.trackingLinkNotActive");
  if (message === "noLink") return t("detail.linkError");
  return message || t("detail.linkError");
};
